import { render, staticRenderFns } from "./CardButton.vue?vue&type=template&id=3ceaac24&scoped=true&lang=pug&"
import script from "./CardButton.vue?vue&type=script&lang=js&"
export * from "./CardButton.vue?vue&type=script&lang=js&"
import style0 from "./CardButton.vue?vue&type=style&index=0&id=3ceaac24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ceaac24",
  null
  
)

export default component.exports